<template>
  <div>
    <div v-if="variant !== 'sidepanel'" class="mt-6 pt-0" style="width:100%;position: relative;">

      <div class="d-flex justify-space-between flex-row">
        <div v-if="databaseType==1" class=" text-h4 ">
          COMPOSITION
        </div>
        <div v-else class="d-flex justify-start">
          <div class="v-label mt-2 mr-3  font-weight-bold">STANDARD ALLOY </div>
          <CSelect class="mt-0 pt-0" :height="35" dense :items="standardAlloys" v-model="selectedStandardAlloy" item-text="name" item-value="id" @change="loadStandardAlloyProps()" single-line></CSelect>
        </div>
        <v-radio-group class="mt-0" row v-model="compositionType" mandatory @change="onPropertiesTypeChanged()">
          <template v-slot:label>
            <div class="v-label">Alloy composition in</div>
          </template>
          <v-radio value="COMPOSITION_AT" >
            <template v-slot:label>
              <div class="compositionRadio"> at%</div>
            </template>
          </v-radio>
          <v-radio value="COMPOSITION_WT">
            <template v-slot:label>
              <div class="compositionRadio"> wt%</div>
            </template>
          </v-radio>
        </v-radio-group>

      </div>

      <div v-if="databaseType==2">
        <v-row v-for="(n,i) in Math.ceil(standardAlloyProperties.length / 4)" :key="i" >
          <v-col v-for="prp in standardAlloyProperties.slice(i*4,(i+1)*4) " :key="prp.id">
            <v-row class="mt-2">
              <v-col class="pr-0" cols="3"><span class="v-label text--secondary ">{{prp.id}} </span></v-col>
              <v-col class="pl-0" cols="9"><span class="numbers black--text">{{prunNum(prp.value)}}</span></v-col>
            </v-row>
          </v-col>
          <template v-if="(i == Math.ceil(standardAlloyProperties.length / 4) - 1 )">
            <v-col v-for="(x,j) in standardAlloyProperties.length % 4" :key="j"></v-col>
          </template>

        </v-row>
      </div>
      <div v-if="databaseType==1" >
        <v-row class="my-n3" v-for="(n,i) in Math.ceil(datasetCompositionFields.length / 4)" :key="i" >
          <v-col  v-for="prp in datasetCompositionFields.slice(i*4,(i+1)*4) " :key="prp.id">
            <div >
              <CTextField :border="'1px'"  height="48px" hide-details v-if="prp.groups.findIndex(g => g.groupType === 'ALUMINIUM') !== -1"  class="pt-0" v-model="selectedProperties[prp.name]" disabled :cLabel="prp.title" autocomplete="off" :name="'mtx-comp-' + prp.name"></CTextField>
              <CTextField :border="'1px'" :changed="(selectedProperties[prp.name]?true:false)" height="48px" hide-details v-else class="pt-0" :error="isCompositionFieldInvalid(prp)" :value="selectedProperties[prp.name]" @change="onPropValueChange(prp, $event)" @blur="onPropValueBlur(prp, $event)" :cLabel="prp.title" autocomplete="off" :name="'mtx-comp-' + prp.name"></CTextField>
              <div class="d-flex justify-space-between  text-caption number grey--text text--darken-1 mt-1">
                <div> {{prunNum(prp.stats.min)}} </div>
                <div>{{prunNum(prp.stats.max)}}</div>
              </div>
            </div>
          </v-col>
          <template v-if="(i == Math.ceil(datasetCompositionFields.length / 4) - 1 )">
            <v-col v-for="(x,j) in datasetCompositionFields.length % 4" :key="j"></v-col>
          </template>
        </v-row>
      </div>
    <div class="d-flex justify-space-between mt-11">
      <v-radio-group class="mt-0" row v-model="selectedHeatTreatment" mandatory>
        <template v-slot:label>
          <div class="v-label">Heat treatment type</div>
        </template>
        <v-radio v-for="item in heatTreatmentTypes" :key="item.id" :value="item.id">
          <template v-slot:label>
            <div class="compositionRadio"> {{item.name}}</div>
          </template>
        </v-radio>
      </v-radio-group>
      <div class="d-flex justify-start ">
        <div class="v-label mt-2 mr-3 grey--text text--darken-2">Casting</div>
        <CSelect :height="32" class="mt-0 pt-0 " dense :items="castingGroups" v-model="selectedCastingGroups" item-text="name" item-value="id" single-line></CSelect>
      </div>
    </div>
    <div class="d-flex">
        <CBtn color="primary" class="mx-auto px-8" :disabled="databaseType === 2 && selectedStandardAlloy === -1" prepen @click="onExplore()">
          <v-icon left>
            mdi-magnify
          </v-icon>          
          Look Up
        </CBtn>
    </div>
    </div>

    <div v-else class="w-full" style="font-family: 'Inter', sans-serif;">
    <!-- Tabs (Normal vs Standard) are controlled by parent via databaseType -->

    <div
        v-if="isFieldsLoading"
        class="flex min-h-[min(280px,42vh)] flex-col items-center justify-center rounded-xl border border-gray-200 bg-white px-6 py-16 shadow-sm dark:border-white/10 dark:bg-white/5 dark:shadow-none"
    >
      <div class="flex flex-col items-center justify-center gap-5 text-center text-gray-700 dark:text-gray-300">
        <div
            class="h-12 w-12 shrink-0 rounded-full border-4 border-gray-300 border-t-gray-700 animate-spin dark:border-white/20 dark:border-t-white"
        ></div>
        <div class="text-base font-medium">Loading dataset fields…</div>
      </div>
    </div>

    <template v-else>
    <!-- Composition fixed to wt% for Predix sidepanel (no AT/WT toggle) -->
    <form autocomplete="off" @submit.prevent>
    <!-- Composition grid — predix-main-inputs only on Main DB (not Benchmark) -->
    <div
      class="grid grid-cols-2 gap-3"
      :data-tour="isBaseDatabase ? 'predix-main-inputs' : undefined"
    >
      <div v-if="showStandardAlloyPicker" class="col-span-2 space-y-1" data-tour="predix-benchmark-input">
        <div class="flex flex-col items-start text-left">
          <label
            for="predix-standard-alloy"
            class="mb-3 block w-full text-left text-sm font-medium text-gray-700 dark:text-gray-200"
          >
            Standard alloy
          </label>
          <div class="predix-comp-select-wrap mb-2 w-full" ref="standardAlloyDropdown">
            <button
              id="predix-standard-alloy"
              type="button"
              class="predix-comp-select"
              :class="{ 'predix-comp-select--open': standardAlloyMenuOpen }"
              aria-haspopup="listbox"
              :aria-expanded="standardAlloyMenuOpen ? 'true' : 'false'"
              @click="toggleStandardAlloyMenu"
              @keydown.down.prevent="openStandardAlloyMenu"
              @keydown.esc="closeStandardAlloyMenu"
            >
              <span :class="{ 'predix-comp-select__placeholder': selectedStandardAlloy === -1 }">
                {{ selectedStandardAlloyLabel }}
              </span>
              <svg
                class="predix-comp-select__chevron"
                viewBox="0 0 20 20"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M5 7.5L10 12.5L15 7.5"
                  stroke="currentColor"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <ul
              v-if="standardAlloyMenuOpen"
              class="predix-comp-menu"
              role="listbox"
            >
              <li
                v-for="a in standardAlloys"
                :key="a.id"
                class="predix-comp-menu__item"
                :class="{ 'predix-comp-menu__item--active': String(a.id) === String(selectedStandardAlloy) }"
                role="option"
                :aria-selected="String(a.id) === String(selectedStandardAlloy) ? 'true' : 'false'"
                @click="selectStandardAlloy(a.id)"
              >
                {{ a.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        v-for="prp in datasetCompositionFields"
        :key="prp.id"
        class="space-y-1"
      >

        <div class="flex-1 flex flex-col items-start text-left">
          <label class="mb-3 block w-full text-left text-sm font-medium text-gray-700 dark:text-gray-200" :for="'predix-comp-' + prp.id">{{ prp.title }}{{ compositionFieldSuffix }}</label>
          <CTailwindInput
                  :id="'predix-comp-' + prp.id"
                  :name="'mtx-comp-' + prp.name"
                  class="mb-2 w-full max-w-full"
                  type="text"
                  inputmode="decimal"
                  autocomplete="off"
                 :error="isCompositionFieldInvalid(prp)"
                 :disabled="isCompositionReadOnly || prp.groups.findIndex(g => g.groupType === 'ALUMINIUM') !== -1"
                 :placeholder="prp.stats ? `${prunNum(prp.stats.min)} - ${prunNum(prp.stats.max)}` : ''"
                 :value="selectedProperties[prp.name]"
                 @input="onPropValueChange(prp, $event)"
                 @blur="onPropValueBlur(prp, $event)"/>
        </div>

      </div>


    </div>

    <hr class="my-3 border-gray-200 dark:border-white/10" />


    <c-tailwind-btn
      type="button"
      variant="primary"
      data-tour="predix-start-prediction"
      class="mt-3 flex min-h-[3rem] w-full items-center justify-center py-3"
      :disabled="isFieldsLoading || isLoading || (showStandardAlloyPicker && selectedStandardAlloy === -1)"
      @click="onExplore()"
    >
      <span class="inline-flex items-center justify-center gap-3">
        <span
            v-if="isLoading"
            class="h-6 w-6 shrink-0 rounded-full border-[3px] border-white/35 border-t-white animate-spin"
        ></span>
        <Icon
            v-else
            id="ai-sparkles"
            size="1.375rem"
            class="shrink-0"
        />
        <span class="text-[0.9375rem] font-semibold tracking-wide">{{ isLoading ? 'Predicting…' : 'START PREDICTION' }}</span>
      </span>
    </c-tailwind-btn>
    </form>
    </template>
  </div>
  </div>
</template>
<script>
import { getData} from '@/api/user/dataset'
import {getDatasetFieldsByOneOfGroups} from '@/api/dataset'
import { smartPruneNumber } from '@/utils/number'
import { sortCompositionFields } from '@/utils/alloyElementOrder'
import CTextField from '@/components/Vuetify/CTextField.vue'
import CSelect from '@/components/Vuetify/CSelect.vue'
import CBtn from '@/components/Vuetify/CBtn.vue'
import CTailwindBtn from "@/components/Vuetify/CTailwindBtn.vue";
import CTailwindInput from "@/components/Vuetify/CTailwindInput.vue";
import Icon from "@/components/Icon.vue";
// import {loadDatasetFields} from '@/api/settings'
// import VueApp from '@/main'

export default {

  name:'AlloySelector',
  components:{CTailwindInput, CTailwindBtn, CTextField, CSelect, CBtn, Icon},
  props:{
      variant: {
        type: String,
        default: 'classic',
      },
      databaseId: {
        type: Number,
        default: -1
      },
      databaseType:{
        type: Number,
        default:1
      },
      fieldGroups:{
        type: Array,
        default: () =>[]
      },
      package_id:{
        type: Number,
        default: 0
      },
      standardAlloys:{
        type: Array,
        default: () => []
      },
      standardDatabaseId: {
        type: Number,
        default: -1,
      },
  },

    data: () => ({
      compositionType: 'COMPOSITION_WT',

      heatTreatmentTypes:[],
      selectedHeatTreatment: 0,
      castingGroups:[],
      selectedCastingGroups:0,

      selectedProperties:{},
      compositionByTitle: {},
      compositionManuallyEdited: false,
      selectedStandardAlloy: -1,
      standardAlloyMenuOpen: false,
      standardAlloyProperties:[],

      datasetFields:[],
      datasetCompositionFields:[],
      invalidCompositionFields: {},
      isFieldsLoading: false,
      isLoading: false,
      fieldsLoadSeq: 0,
      pendingFieldsLoad: false,

      rules: {
        isNumber: v => (! isNaN(v) || v === undefined  || v === null || v === "" )
      }
    }),
    created() {
      this.ensureDefaultStandardAlloy()
      if( this.databaseId >= 0 ){
        // this.heatTreatmentTypes = this.fieldGroups.filter(item => item.groupType === 'HEAT TREATMENT')
        // this.castingGroups = this.fieldGroups.filter(item => item.groupType === 'CASTING')
        // if (this.heatTreatmentTypes.length > 0){
        //     this.selectedHeatTreatment = this.heatTreatmentTypes[0].id
        // }
        // if (this.castingGroups.length > 0){
        //   this.selectedCastingGroups = this.castingGroups[0].id
        // }
        // if( this.databaseType === 1 ){
          this.loadDatasetFields()
        // }
      }
    },
    beforeDestroy() {
      document.removeEventListener('click', this.onStandardAlloyOutsideClick, true)
    },
    watch:{
      databaseId(newVal, oldVal){
        if (newVal === oldVal) return

        if (this.variant === 'sidepanel') {
          if (newVal >= 0) {
            this.loadDatasetFields()
          }
          return
        }

        if(oldVal == -1 && newVal !== -1){
          // this.heatTreatmentTypes = this.fieldGroups.filter(item => item.groupType === 'HEAT TREATMENT')
          // this.castingGroups = this.fieldGroups.filter(item => item.groupType === 'CASTING')
          // if (this.heatTreatmentTypes.length > 0){
          //     this.selectedHeatTreatment = this.heatTreatmentTypes[0].id
          // }
          // if (this.castingGroups.length > 0){
          //   this.selectedCastingGroups = this.castingGroups[0].id
          // }
        }
        this.reset()
        this.loadDatasetFields()
      },
      standardAlloys: {
        immediate: true,
        handler(newList) {
          this.ensureDefaultStandardAlloy()
          if (
            this.isBenchmarkSidepanel() &&
            this.datasetCompositionFields.length &&
            this.isFieldsLoading &&
            Array.isArray(newList) &&
            newList.length === 0
          ) {
            this.isFieldsLoading = false
          }
        },
      },
      fieldGroups(newVal){
        // fieldGroups is loaded asynchronously by the parent. If a field load was
        // requested before the groups arrived, run it now that they're available.
        if (newVal && newVal.length && this.databaseId >= 0 && this.pendingFieldsLoad) {
          this.loadDatasetFields()
        }
      },
      selectedStandardAlloy(newVal, oldVal) {
        if (this.variant !== 'sidepanel') return
        if (!this.isBenchmarkDatabase) return
        if (newVal === -1 || newVal === null || newVal === '') return
        if (String(newVal) === String(oldVal)) return
        if (!this.datasetCompositionFields.length) return

        this.compositionManuallyEdited = false
        // If an initial benchmark load is still showing the full-panel spinner
        // (alloys only just arrived), keep it until the values load; otherwise a
        // plain alloy switch updates inputs inline without a full reload.
        this.loadStandardAlloyProps(this.isFieldsLoading)
      },
      databaseType(newVal, oldVal) {
        if (this.variant !== 'sidepanel') return
        if (Number(newVal) === Number(oldVal)) return

        this.compositionManuallyEdited = false
        this.clearCompositionFields()

        if (this.isBaseDatabase) {
          this.selectedStandardAlloy = -1
        }
      },
    },
    computed: {
      isBaseDatabase() {
        return Number(this.databaseType) === 1;
      },
      isBenchmarkDatabase() {
        return Number(this.databaseType) === 2;
      },
      showStandardAlloyPicker() {
        return this.variant === 'sidepanel' && this.isBenchmarkDatabase && this.standardAlloys.length > 0;
      },
      isCompositionReadOnly() {
        return this.variant === 'sidepanel' && this.isBenchmarkDatabase;
      },
      compositionFieldSuffix() {
        return this.compositionType === 'COMPOSITION_AT' ? ' (at%)' : '';
      },
      selectedStandardAlloyLabel() {
        const entry = this.standardAlloys.find(
          (item) => String(item.id) === String(this.selectedStandardAlloy)
        )
        return entry ? entry.name : 'Select alloy'
      },
    },
    methods: {
      isBenchmarkSidepanel() {
        return this.variant === 'sidepanel' && this.isBenchmarkDatabase;
      },
      toggleStandardAlloyMenu() {
        if (this.standardAlloyMenuOpen) {
          this.closeStandardAlloyMenu()
        } else {
          this.openStandardAlloyMenu()
        }
      },
      openStandardAlloyMenu() {
        if (this.standardAlloyMenuOpen) return
        this.standardAlloyMenuOpen = true
        document.addEventListener('click', this.onStandardAlloyOutsideClick, true)
      },
      closeStandardAlloyMenu() {
        if (!this.standardAlloyMenuOpen) return
        this.standardAlloyMenuOpen = false
        document.removeEventListener('click', this.onStandardAlloyOutsideClick, true)
      },
      onStandardAlloyOutsideClick(event) {
        const wrap = this.$refs.standardAlloyDropdown
        if (wrap && !wrap.contains(event.target)) {
          this.closeStandardAlloyMenu()
        }
      },
      selectStandardAlloy(id) {
        this.selectedStandardAlloy = id
        this.closeStandardAlloyMenu()
        this.loadStandardAlloyProps()
      },
      ensureDefaultStandardAlloy(){
        if (this.variant !== 'sidepanel') return
        if (!this.isBenchmarkDatabase) return
        if (!this.standardAlloys || this.standardAlloys.length === 0) return

        const hasSelection = this.standardAlloys.some(
          (item) => String(item.id) === String(this.selectedStandardAlloy)
        )
        if (!hasSelection) {
          this.selectedStandardAlloy = this.standardAlloys[0].id
        }
      },
      clearCompositionFields() {
        this.selectedProperties = {}
        this.compositionByTitle = {}
        this.compositionManuallyEdited = false
        this.invalidCompositionFields = {}
      },
      reset(){
        this.selectedProperties = {}
        this.compositionByTitle = {}
        this.compositionManuallyEdited = false
        this.exploreResult = []
        this.datasetFields = []
        this.selectedStandardAlloy = -1
        this.standardAlloyProperties = []
        this.datasetCompositionFields = []
        this.invalidCompositionFields = {}
        this.heatTreatmentTypes=[]
        this.castingGroups =[]
        this.isFieldsLoading = false
        this.isLoading = false
      },
      onExplore(){
        if (this.isBaseDatabase && !this.validateComposition()) {
          return
        }
        this.loadResult()
      },
      // For the Main database the user must provide every element composition before
      // a prediction can run (aluminium is auto-balanced and therefore not required).
      validateComposition(){
        const missing = this.datasetCompositionFields.filter(prp => {
          const isAluminium = prp.groups.findIndex(g => g.groupType === 'ALUMINIUM') !== -1
          if (isAluminium) {
            return false
          }
          return this.normalizeCompositionValue(this.selectedProperties[prp.name]) === null
        })

        if (missing.length > 0) {
          if (this.$root && this.$root.notify) {
            this.$root.notify.show({
              message: 'Please enter percentages for all alloying elements before running predictions.',
              type: 'warning',
            })
          }
          return false
        }

        const outOfRange = this.datasetCompositionFields.filter((prp) => {
          const isAluminium = prp.groups.findIndex(g => g.groupType === 'ALUMINIUM') !== -1
          if (isAluminium) {
            return false
          }
          const normalized = this.normalizeCompositionValue(this.selectedProperties[prp.name])
          if (normalized === null) {
            return false
          }
          return !this.isValueInStatsRange(prp, normalized)
        })

        if (outOfRange.length > 0) {
          outOfRange.forEach((prp) => {
            this.$set(this.invalidCompositionFields, prp.name, true)
            this.$delete(this.selectedProperties, prp.name)
            this.$delete(this.compositionByTitle, prp.title)
          })
          this.recalcAluminumBalance()
          this.showCompositionRangeError()
          return false
        }

        return true
      },
      isCompositionFieldInvalid(prp) {
        return Boolean(this.invalidCompositionFields[prp.name])
      },
      isCompleteNumberString(str) {
        const s = String(str).trim()
        if (s === '' || s === '.' || s === '-' || s === '-.' || s.endsWith('.')) {
          return false
        }
        return !Number.isNaN(Number(s))
      },
      // Allow partial decimal entry while typing (e.g. "0.", "0.0", ".01").
      isAllowedCompositionInput(str) {
        const s = String(str).trim()
        if (s === '' || s === '-' || s === '-.') {
          return false
        }
        return /^-?\d*\.?\d*$/.test(s)
      },
      normalizeCompositionValue(val) {
        if (val === undefined || val === null || val === '') {
          return null
        }
        const strVal = String(val).trim()
        if (!this.isCompleteNumberString(strVal)) {
          return null
        }
        const num = Number(strVal)
        if (Number.isNaN(num)) {
          return null
        }
        if (strVal.includes('.')) {
          const decimalPlaces = strVal.split('.')[1].length
          return Number(num.toFixed(Math.min(decimalPlaces, 6)))
        }
        return smartPruneNumber(num)
      },
      normalizeStatBound(val) {
        if (val === undefined || val === null || val === '') {
          return null
        }
        const num = Number(val)
        if (Number.isNaN(num)) {
          return null
        }
        return num
      },
      isValueInStatsRange(prp, val) {
        if (!prp || !prp.stats) {
          return true
        }
        const num = this.normalizeCompositionValue(val)
        if (num === null) {
          return false
        }

        let min = this.normalizeStatBound(prp.stats.min)
        let max = this.normalizeStatBound(prp.stats.max)

        // Guard against bounds arriving in the wrong order.
        if (min !== null && max !== null && min > max) {
          const tmp = min
          min = max
          max = tmp
        }

        // Relative tolerance so float-precision noise in the stored bounds
        // (e.g. 0.2000000001) never rejects a value the user sees as in range.
        const magnitude = Math.max(
          Math.abs(num),
          min !== null ? Math.abs(min) : 0,
          max !== null ? Math.abs(max) : 0
        )
        const tolerance = magnitude * 1e-6 + 1e-9

        if (min !== null && num < min - tolerance) {
          return false
        }
        if (max !== null && num > max + tolerance) {
          return false
        }
        return true
      },
      showCompositionRangeError() {
        if (this.$root && this.$root.notify) {
          this.$root.notify.show({
            message: 'Please ensure all percentages are within the defined composition range.',
            type: 'error',
          })
        }
      },
      rejectOutOfRangeValue(prp) {
        this.$set(this.invalidCompositionFields, prp.name, true)
        this.$delete(this.selectedProperties, prp.name)
        this.$delete(this.compositionByTitle, prp.title)
        this.showCompositionRangeError()
        this.recalcAluminumBalance()
      },


      getIndicatorPosition(min, max, value, length){
        const bias = 10
        if (min == max || value == min){
          return bias
        } else if ( value > max) {
          return bias + length
        } else if ( value < min) {
          return bias
        } else
        {
          return bias +  (value * length)/(max - min)
        }
      },
      prunNum(num){
        return smartPruneNumber(num)
      },
      onPropValueChange(prp, val){
        if (this.isCompositionReadOnly) {
          return
        }

        if (this.invalidCompositionFields[prp.name]) {
          this.$delete(this.invalidCompositionFields, prp.name)
        }

        if (typeof val === 'object' && val != null && val.target != null) {
          val = val.target.value
        }

        this.compositionManuallyEdited = true

        if (val === '' || val === null || val === undefined) {
          this.$delete(this.selectedProperties, prp.name)
          this.$delete(this.compositionByTitle, prp.title)
          this.recalcAluminumBalance()
          return
        }

        const strVal = String(val).trim()
        if (!this.isAllowedCompositionInput(strVal)) {
          return
        }

        // Keep the raw string while typing; normalize on blur so values like 0.01 / 0.002
        // are not collapsed to 0 when the user enters intermediate "0.0".
        this.$set(this.selectedProperties, prp.name, strVal)
        this.$set(this.compositionByTitle, prp.title, strVal)
        this.recalcAluminumBalance()
      },
      onPropValueBlur(prp, evt){
        if (this.isCompositionReadOnly) {
          return
        }

        let raw = ''
        if (typeof evt === 'object' && evt != null && evt.target != null) {
          raw = String(evt.target.value).trim()
        } else if (evt !== undefined && evt !== null) {
          raw = String(evt).trim()
        }

        if (raw === '') {
          return
        }

        if (!this.isCompleteNumberString(raw)) {
          return
        }

        const normalized = this.normalizeCompositionValue(raw)
        if (normalized === null) {
          return
        }

        this.$set(this.selectedProperties, prp.name, normalized)
        this.$set(this.compositionByTitle, prp.title, normalized)

        if (!this.isValueInStatsRange(prp, normalized)) {
          this.rejectOutOfRangeValue(prp)
          return
        }

        this.recalcAluminumBalance()
      },
      recalcAluminumBalance(){
        const alluminum = this.datasetCompositionFields.find(prp => prp.groups.findIndex(g => g.groupType === 'ALUMINIUM') !== -1)
        if (!alluminum) {
          return
        }

        let sum = 0
        for (const alloyName of Object.keys(this.selectedProperties)) {
          if (alloyName !== alluminum.name) {
            sum += Number(this.selectedProperties[alloyName]) || 0
          }
        }

        this.$set(this.selectedProperties, alluminum.name, smartPruneNumber(100 - sum))
        this.$set(this.compositionByTitle, alluminum.title, smartPruneNumber(100 - sum))
      },
      normalizeAlloyKey(key) {
        return String(key || '').trim().toLowerCase()
      },
      resolveAlloyFieldValue(alloy, field) {
        if (!alloy || !field) {
          return undefined
        }

        const candidates = [field.title, field.name]
        for (const candidate of candidates) {
          if (candidate !== undefined && candidate !== null && alloy[candidate] !== undefined) {
            return alloy[candidate]
          }
        }

        const targetTitle = this.normalizeAlloyKey(field.title)
        const targetName = this.normalizeAlloyKey(field.name)
        for (const key of Object.keys(alloy)) {
          const normalized = this.normalizeAlloyKey(key)
          if (normalized === targetTitle || normalized === targetName) {
            return alloy[key]
          }
        }

        return undefined
      },
      applyCompositionFromAlloy(alloy) {
        if (!alloy || !this.datasetCompositionFields.length) {
          return
        }

        let appliedAny = false

        this.datasetCompositionFields.forEach((field) => {
          const raw = this.resolveAlloyFieldValue(alloy, field)
          if (raw === undefined || raw === null || raw === '') {
            this.$delete(this.selectedProperties, field.name)
            this.$delete(this.compositionByTitle, field.title)
            return
          }

          const num = Number(raw)
          if (Number.isNaN(num)) {
            this.$delete(this.selectedProperties, field.name)
            this.$delete(this.compositionByTitle, field.title)
            return
          }

          const value = smartPruneNumber(num)
          this.$set(this.selectedProperties, field.name, value)
          this.$set(this.compositionByTitle, field.title, value)
          appliedAny = true
        })

        // If nothing matched (e.g. element names differ between databases), keep
        // existing values rather than wiping the whole composition.
        if (!appliedAny) {
          return
        }

        this.standardAlloyProperties.forEach((element) => {
          const raw = this.resolveAlloyFieldValue(alloy, { title: element.id, name: element.id })
          element.value = raw === undefined ? null : raw
        })

        this.compositionManuallyEdited = false
        this.recalcAluminumBalance()
      },
      resolvedStandardAlloyId() {
        const entry = this.standardAlloys.find(
          (item) => String(item.id) === String(this.selectedStandardAlloy)
        )
        return entry ? entry.id : this.selectedStandardAlloy
      },
      onPropertiesTypeChanged(){
        this.$emit('composition-type-change', this.compositionType);
        this.loadDatasetFields();
        if (this.databaseType == 2) {
          this.loadStandardAlloyProps();
        }
      },
      loadStandardAlloyProps(showLoader = false){
          const alloyId = this.resolvedStandardAlloyId()
          const awaitingBenchmarkContent = showLoader && this.isBenchmarkSidepanel()
          if (alloyId === -1 || alloyId === null || alloyId === '') {
            if (awaitingBenchmarkContent) {
              this.isFieldsLoading = false
            }
            return
          }

          const sourceDatabaseId = this.standardDatabaseId >= 0 ? this.standardDatabaseId : this.databaseId
          if (sourceDatabaseId < 0) {
            if (awaitingBenchmarkContent) {
              this.isFieldsLoading = false
            }
            return
          }

          const alloyGroup = this.fieldGroups.find(item => item.groupType === this.compositionType)
          if (!alloyGroup) {
            if (awaitingBenchmarkContent) {
              this.isFieldsLoading = false
            }
            return
          }

          const _this = this
          const loadId = this.fieldsLoadSeq
          if (awaitingBenchmarkContent) {
            this.isFieldsLoading = true
          }
          getData(
            this.package_id,
            sourceDatabaseId,
            [{ f0: alloyId }],
            [alloyGroup.id],
            function(res) {
              if (loadId !== _this.fieldsLoadSeq || !_this.isBenchmarkDatabase) {
                return
              }

              if (!res.result || !res.result.length) {
                if (awaitingBenchmarkContent) {
                  _this.isFieldsLoading = false
                }
                return
              }

              _this.applyCompositionFromAlloy(res.result[0])
              if (awaitingBenchmarkContent) {
                _this.isFieldsLoading = false
              }
            }
          )
      },
      loadDatasetFields(){
        const _this = this
        if (this.databaseId < 0) {
          return
        }

        // fieldGroups arrives asynchronously from the parent. If it isn't ready yet,
        // show the spinner and defer the actual fetch until the fieldGroups watcher
        // fires — otherwise the lookup below would throw and the request never sends.
        const alloyNameGroup = (this.fieldGroups || []).find(item => item.groupType === this.compositionType)
        if (!alloyNameGroup) {
          this.pendingFieldsLoad = true
          this.isFieldsLoading = true
          return
        }
        this.pendingFieldsLoad = false

        const loadId = ++this.fieldsLoadSeq
        _this.isFieldsLoading = true
        const alloyNameGroupId = alloyNameGroup.id
        const groupTypes = ['ALUMINIUM', 'CASTING' , 'HEAT TREATMENT','COMPOSITION_AT','COMPOSITION_WT']
        const groups =  this.fieldGroups.filter(g => groupTypes.includes(g.groupType)).map(item => item.id)
        getDatasetFieldsByOneOfGroups(this.databaseId, groups, function(res){
          if (loadId !== _this.fieldsLoadSeq) {
            return
          }
          _this.datasetFields = res
          // _this.datasetFields = res.filter(f => f.groups.filter(g => groupTypes.includes(g.groupType)).length > 0)
          let groups = new Set()
          let heatTreatmens = new Set()
          _this.datasetFields.forEach(item => item.groups.filter(grp => grp.groupType === 'CASTING').forEach(g => groups.add(g.id)))
          _this.datasetFields.forEach(item => item.groups.filter(grp => grp.groupType === 'HEAT TREATMENT').forEach(g => heatTreatmens.add(g.id)))
          _this.castingGroups = _this.fieldGroups.filter(item => groups.has(item.id))
          _this.heatTreatmentTypes = _this.fieldGroups.filter(item => heatTreatmens.has(item.id))


          if (_this.heatTreatmentTypes.length > 0){
              _this.selectedHeatTreatment = _this.heatTreatmentTypes[0].id
          }
          if (_this.castingGroups.length > 0){
            _this.selectedCastingGroups = _this.castingGroups[0].id
          }


          _this.datasetCompositionFields = sortCompositionFields(
            res.filter(item => item.groups.findIndex(grp => grp.id === alloyNameGroupId) !== -1)
          )
          _this.standardAlloyProperties = _this.datasetCompositionFields.map(item => { return {id:item.title, value: null} })

          if (_this.variant === 'sidepanel' && _this.isBenchmarkDatabase) {
            _this.clearCompositionFields()
          } else if (_this.variant === 'sidepanel' && _this.isBaseDatabase) {
            _this.clearCompositionFields()
          } else {
            const preserved = { ..._this.selectedProperties }
            Object.keys(_this.selectedProperties).forEach((key) => {
              if (!_this.datasetCompositionFields.find((field) => field.name === key)) {
                _this.$delete(_this.selectedProperties, key)
              }
            })
            _this.datasetCompositionFields.forEach((field) => {
              const saved = preserved[field.name]
              const savedByTitle = _this.compositionByTitle[field.title]
              if (savedByTitle !== undefined && savedByTitle !== null && savedByTitle !== '') {
                _this.$set(_this.selectedProperties, field.name, savedByTitle)
              } else if (saved !== undefined && saved !== null && saved !== '') {
                _this.$set(_this.selectedProperties, field.name, saved)
                _this.$set(_this.compositionByTitle, field.title, saved)
              }
            })

            const al = _this.datasetCompositionFields.find(prp => prp.groups.findIndex(g => g.groupType === 'ALUMINIUM') !== -1)
            if (al) {
              const hasOtherValues = _this.datasetCompositionFields.some(
                (field) => field.name !== al.name && _this.selectedProperties[field.name] !== undefined && _this.selectedProperties[field.name] !== ''
              )
              if (!hasOtherValues && _this.selectedProperties[al.name] === undefined) {
                _this.$set(_this.selectedProperties, al.name, 100)
                _this.$set(_this.compositionByTitle, al.title, 100)
              } else {
                _this.recalcAluminumBalance()
              }
            }
          }

          const al = _this.datasetCompositionFields.find(prp => prp.groups.findIndex(g => g.groupType === 'ALUMINIUM') !== -1)
          if (al && _this.variant === 'sidepanel' && _this.isBaseDatabase && Object.keys(_this.selectedProperties).length) {
            _this.recalcAluminumBalance()
          }

          if (_this.isBenchmarkSidepanel()) {
            _this.ensureDefaultStandardAlloy()
            if (_this.selectedStandardAlloy !== -1) {
              _this.loadStandardAlloyProps(true)
              return
            }
            if (!_this.standardAlloys.length) {
              return
            }
          }

          _this.isFieldsLoading = false

        }, function(){
          // If the fields request fails, clear the spinner so the UI doesn't hang.
          if (loadId !== _this.fieldsLoadSeq) {
            return
          }
          _this.isFieldsLoading = false
        })
      },
      // Resolve an aggregations container from the explore response, tolerating
      // different backend key names (standardDatasetAggregations / snake_case / etc.).
      getAggregations(res, preferStandard){
        if (!res) {
          return null
        }
        const aggKeys = Object.keys(res).filter(k => /aggregation/i.test(k))
        if (preferStandard) {
          const std = aggKeys.find(k => /standard|benchmark/i.test(k))
          if (std && res[std]) {
            return res[std]
          }
        } else {
          const main = aggKeys.find(k => !/standard|benchmark/i.test(k))
          if (main && res[main]) {
            return res[main]
          }
        }
        for (const k of aggKeys) {
          if (res[k]) {
            return res[k]
          }
        }
        return null
      },
      // Look up min/max/avg stats for a field. Supports both the new backend shape
      // (a dict keyed by internal field name, e.g. { f1: { min, max, avg } }) and the
      // legacy array shape ([{ "<title>": { min, max } }]). Keys may be name or title.
      statsForField(f, aggs){
        if (!f || !aggs) {
          return {}
        }
        if (Array.isArray(aggs)) {
          const entry = aggs.find(item => {
            const k = Object.keys(item)[0]
            return k === f.title || k === f.name
          })
          return entry ? entry[Object.keys(entry)[0]] : {}
        }
        return aggs[f.name] || aggs[f.title] || {}
      },
      buildExploreResult(rs, aggs){
        const _this = this
        const exploreResult = []
        for (const key of Object.keys(rs)) {
          const f = _this.datasetFields.find(f => f.title == key)
          if (!f) {
            continue
          }
          const stats = _this.statsForField(f, aggs)
          exploreResult.push({
            "name": key,
            "value": rs[key],
            "stats": stats,
            "id": f.id,
            "order": Number(f.name.slice(1)),
            "groups": f.groups.map(g => g.id),
          })
        }
        exploreResult.sort((a, b) => a.order - b.order)
        return exploreResult
      },
      buildCompositionReportItems() {
        const items = []
        for (const field of this.datasetCompositionFields || []) {
          const raw = this.selectedProperties[field.name]
          if (raw === undefined || raw === null || raw === '') continue
          const n = Number(raw)
          items.push({
            id: field.id != null ? `comp-${field.id}` : `comp-${field.name}`,
            name: field.title || field.name,
            value: Number.isFinite(n) ? n : raw,
          })
        }
        return items
      },
      emitExplore(exploreResult, databaseFields, heatTreatment, castingGroups) {
        this.$emit(
          'onExplore',
          exploreResult,
          databaseFields,
          heatTreatment,
          castingGroups,
          this.databaseType,
          this.buildCompositionReportItems()
        )
      },
      loadResult(){
        const _this = this
        _this.$emit('onExploreStart')
        _this.isLoading = true

        var groups = [ _this.selectedCastingGroups, _this.selectedHeatTreatment ]
        var datasetId = 0
        var filters = []
        if(this.databaseType == 1){ // Normal
          datasetId = this.databaseId
          filters = this.datasetCompositionFields.map(
            item => {
              var r ={}
              const raw = this.selectedProperties[item.name]
              r[item.name] = (raw === undefined || raw === null || raw === '' || Number.isNaN(Number(raw)))
                ? 0
                : Number(raw)
              return r
            }
          )

          getData(_this.package_id, datasetId, filters, groups, function(res){
            if ( res.result.length == 0){
              _this.isLoading = false
              _this.emitExplore([], [], 0, 0)
              return
            }
            const aggs = _this.getAggregations(res, false) || res.aggregation
            const exploreResult = _this.buildExploreResult(res.result[0], aggs)
            _this.isLoading = false
            _this.emitExplore(exploreResult, _this.datasetFields, _this.selectedHeatTreatment, _this.selectedCastingGroups)
          })
          return
        }

        // Standard / Benchmark: the meaningful min/max range for each predicted property
        // comes from the benchmark dataset's distribution (standardDatasetAggregations).
        datasetId = this.databaseId
        filters = [ {"f0": this.selectedStandardAlloy} ]
        getData(_this.package_id, datasetId, filters, groups, function(res){
          if ( res.result.length == 0){
            _this.isLoading = false
            _this.emitExplore([], [], 0, 0)
            return
          }
          const aggs = _this.getAggregations(res, true) || res.aggregation
          const exploreResult = _this.buildExploreResult(res.result[0], aggs)
          _this.isLoading = false
          _this.emitExplore(exploreResult, _this.datasetFields, _this.selectedHeatTreatment, _this.selectedCastingGroups)
        })

      }
  }
}
</script>
<style scoped>

.compositionRadio{
  color: black !important;
}
.theme--dark .compositionRadio{
  color: #EBEAFA !important;

}

.theme--dark .v-label{
  color:#6B7588 !important;
}

.numbers {
  color:rgba(107, 117, 136, 1);
}
.blured {
  filter: blur(1px);
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.v-data-table-header {
  background-color: rgba(182, 183, 187, 0.9);
  color: white;
}

.form-input, .form-textarea {
  &::placeholder {
    color: var(--color-gray-400);
  }
  &:is(.dark *) {
    &::placeholder {
      color: var(--color-gray-500);
    }
  }
}

/* Standard alloy select — match CTailwindInput (.ctw-input) used for composition fields */
.predix-comp-select-wrap {
  width: 100%;
  max-width: 100%;
  position: relative;
}

.predix-comp-select {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0;
  border-style: solid;
  border-width: 1px;
  border-radius: var(--radius-lg);
  border-color: var(--color-gray-200);
  background-color: var(--color-white);
  padding-inline: calc(var(--spacing) * 3);
  padding-block: calc(var(--spacing) * 2);
  font-family: var(--font-inter), var(--font-sans);
  font-size: var(--text-sm);
  line-height: calc(var(--spacing) * 5);
  color: var(--color-gray-800);
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  transition-property: border-color, box-shadow, background-color, color, opacity;
  transition-duration: var(--default-transition-duration);
  transition-timing-function: var(--default-transition-timing-function);
  appearance: none;
  cursor: pointer;
  text-align: left;
}

.predix-comp-select span {
  display: block;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.predix-comp-select__chevron {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  color: var(--color-gray-500);
  transition: transform 0.15s ease;
}

.predix-comp-select--open .predix-comp-select__chevron {
  transform: rotate(180deg);
}

.predix-comp-select__placeholder {
  color: var(--color-gray-400);
}

.predix-comp-menu {
  position: absolute;
  z-index: 40;
  top: calc(100% + 0.25rem);
  left: 0;
  right: 0;
  margin: 0;
  padding: 0.25rem 0;
  list-style: none;
  max-height: 16rem;
  overflow-y: auto;
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-lg);
  background-color: var(--color-white);
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}

.predix-comp-menu__item {
  padding: 0.5rem 0.75rem;
  font-family: var(--font-inter), var(--font-sans);
  font-size: var(--text-sm);
  color: var(--color-gray-800);
  cursor: pointer;
}

.predix-comp-menu__item:hover {
  background-color: var(--color-gray-50);
}

.predix-comp-menu__item--active {
  background-color: color-mix(in srgb, var(--v-primary-base) 10%, var(--color-white));
  color: var(--color-gray-900);
  font-weight: 500;
}

.predix-comp-select:hover:not(:disabled) {
  border-color: var(--color-gray-300);
}

.predix-comp-select:focus {
  outline: none;
  border-color: var(--color-gray-300);
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

html.dark .predix-comp-select {
  background-color: color-mix(in srgb, var(--color-gray-900) 30%, transparent);
  border-color: color-mix(in srgb, var(--color-gray-700) 60%, transparent);
  color: var(--color-gray-100);
}

html.dark .predix-comp-select__chevron {
  color: var(--color-gray-400);
}

html.dark .predix-comp-select__placeholder {
  color: var(--color-gray-500);
}

html.dark .predix-comp-menu {
  border-color: color-mix(in srgb, var(--color-gray-600) 70%, transparent);
  background-color: var(--color-gray-800);
  box-shadow: 0 4px 12px rgb(0 0 0 / 0.45);
}

html.dark .predix-comp-menu__item {
  color: var(--color-gray-200);
}

html.dark .predix-comp-menu__item:hover {
  background-color: color-mix(in srgb, var(--color-gray-700) 45%, transparent);
}

html.dark .predix-comp-menu__item--active {
  background-color: color-mix(in srgb, var(--v-primary-base) 22%, var(--color-gray-800));
  color: var(--color-gray-100);
}

html.dark .predix-comp-select:hover:not(:disabled) {
  border-color: var(--color-gray-600);
}

html.dark .predix-comp-select:focus {
  border-color: var(--color-gray-600);
}

.predix-comp-select:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

</style>